<template>
  <a-drawer
    :title="
      isEdit
        ? $t('cantine.modifierMenuHebdo', { name: menu.name })
        : $t('cantine.ajouterMenuHebdo')
    "
    :width="600"
    :visible="visible"
    :body-style="{ paddingBottom: '80px' }"
    @close="close"
  >
    <a-form :form="form" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item :label="$t('cantine.nomMenu')">
            <a-input
              v-decorator="[
                'name',
                {
                  initialValue: isEdit ? menu.name : undefined,
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: $t('cantine.saisirNomMenu'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('cantine.saisirNomMenu')"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item :label="$t('cantine.descriptionMenu')">
            <a-textarea
              v-decorator="[
                'description',
                { initialValue: isEdit ? menu.description : undefined },
              ]"
              :placeholder="$t('cantine.saisirDescriptionMenu')"
              :auto-size="{ minRows: 3, maxRows: 6 }"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item :label="$t('cantine.dateDebut')">
            <a-date-picker
              format="DD/MM/YYYY"
              v-decorator="[
                'startDate',
                {
                  initialValue: isEdit ? moment(menu.startDate) : undefined,
                  rules: [
                    {
                      required: true,
                      message: $t('cantine.saisirDateDebut'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('cantine.saisirDateDebut')"
              style="width: 100%"
              @change="onStartDateChange"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('all.endDate')">
            <a-date-picker
              format="DD/MM/YYYY"
              v-decorator="[
                'endDate',
                {
                  initialValue: isEdit ? moment(menu.endDate) : undefined,
                  rules: [
                    {
                      required: true,
                      message: $t('cantine.saisirEndDate'),
                    },
                    { validator: validateEndDate },
                  ],
                },
              ]"
              :disabled-date="disabledEndDate"
              :placeholder="$t('cantine.saisirEndDate')"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item :label="$t('cantine.joursWeekend')">
            <a-checkbox
              v-decorator="[
                'includeSaturday',
                {
                  valuePropName: 'checked',
                  initialValue: isEdit ? !!menu.includeSaturday : false,
                },
              ]"
            >
              {{ $t("cantine.inclureSamedi") }}
            </a-checkbox>
            <a-checkbox
              v-decorator="[
                'includeSunday',
                {
                  valuePropName: 'checked',
                  initialValue: isEdit ? !!menu.includeSunday : false,
                },
              ]"
            >
              {{ $t("cantine.inclureDimanche") }}
            </a-checkbox>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item :label="$t('cantine.imageMenu')">
            <a-upload-dragger
              :multiple="false"
              accept="image/png,image/jpeg"
              :before-upload="beforeUpload"
              :file-list="fileList"
              list-type="picture"
              @change="handleUploadChange"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="file-image" />
              </p>
              <p class="ant-upload-text">
                {{ $t("etablissement.clickOrDragToUpload") }}
              </p>
            </a-upload-dragger>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-progress
      v-if="progress.value > 0"
      :stroke-color="{ from: '#108ee9', to: '#87d068' }"
      :percent="progress.value"
      status="active"
    />
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button
        :style="{ marginRight: '8px' }"
        :disabled="loading"
        @click="close"
      >
        {{ $t("action.annuler") }}
      </a-button>
      <a-button
        type="primary"
        :loading="loading"
        :disabled="loading"
        @click="handleSubmit"
      >
        {{ isEdit ? $t("action.modifier") : $t("action.ajouter") }}
      </a-button>
    </div>
  </a-drawer>
</template>
<script>
import apiClient from "@/services/axios";
import { mapState } from "vuex";
import { uploadFilesToS3 } from "@/services/uploadService";
import moment from "moment";

export default {
  name: "WeeklyMenuDrawer",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      startDate: null,
      photo: null,
      fileList: [],
      loading: false,
      progress: { value: 0 },
    };
  },
  computed: {
    ...mapState(["settings"]),
    isEdit() {
      return !!this.menu;
    },
  },
  watch: {
    visible(isVisible) {
      if (isVisible) this.$nextTick(this.reset);
    },
  },
  methods: {
    moment,
    reset() {
      this.form.resetFields();
      this.photo = null;
      if (this.isEdit) {
        this.startDate = moment(this.menu.startDate);
        this.fileList = this.menu.image
          ? [
              {
                uid: "-1",
                name: this.menu.image.split("/").pop(),
                status: "done",
                url: this.imageUrl(this.menu.image),
              },
            ]
          : [];
      } else {
        this.startDate = null;
        this.fileList = [];
      }
    },
    imageUrl(image) {
      if (/^(https?|blob):/.test(image)) return image;
      return this.settings.resourcesUrl.replace("FILE_PATH", image);
    },
    close() {
      if (this.loading) return;
      this.$emit("close");
    },
    onStartDateChange(date) {
      this.startDate = date;
      if (this.form.getFieldValue("endDate")) {
        this.$nextTick(() =>
          this.form.validateFields(["endDate"], { force: true })
        );
      }
    },
    disabledEndDate(current) {
      return (
        !!current && !!this.startDate && current.isBefore(this.startDate, "day")
      );
    },
    validateEndDate(rule, value, callback) {
      const startDate = this.form.getFieldValue("startDate");
      if (value && startDate && value.isBefore(startDate, "day")) {
        callback(this.$t("cantine.endDateAvantDebut"));
      } else {
        callback();
      }
    },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error(this.$t("error.fichiers"));
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(this.$t("error.image"));
      }
      if (isJpgOrPng && isLt5M) {
        this.photo = file;
        this.fileList = [
          {
            uid: "-1",
            name: file.name,
            status: "done",
            url: URL.createObjectURL(file),
          },
        ];
      }
      return false;
    },
    handleUploadChange(info) {
      if (info.file.status === "removed") {
        this.photo = null;
        this.fileList = [];
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) this.saveMenu(values);
      });
    },
    async saveMenu(values) {
      const isEdit = this.isEdit;
      this.loading = true;
      try {
        const data = {
          name: values.name,
          description: values.description,
          startDate: values.startDate.clone().startOf("day").toDate(),
          endDate: values.endDate.clone().startOf("day").toDate(),
          includeSaturday: values.includeSaturday,
          includeSunday: values.includeSunday,
        };
        if (this.photo) {
          const [imageKey] = await uploadFilesToS3(
            [this.photo],
            "manager/canteen",
            this.progress
          );
          data.image = imageKey;
        } else if (isEdit && this.menu.image && this.fileList.length === 0) {
          data.image = null;
        }

        if (isEdit) {
          await apiClient.patch(`/weeklyMenu/${this.menu._id}`, data);
          this.$message.success(this.$t("cantine.menuHebdoModifie"));
        } else {
          await apiClient.post("/weeklyMenu", data);
          this.$message.success(this.$t("cantine.menuHebdoAjoute"));
        }
        this.$emit("saved");
        this.loading = false;
        this.close();
      } catch (e) {
        this.$message.error(
          this.$t(isEdit ? "cantine.errorMessage" : "cantine.errorMessageAdd")
        );
      } finally {
        this.loading = false;
        this.progress = { value: 0 };
      }
    },
  },
};
</script>
